import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

const IconWeChatApp = ({ className, height, width, fill }: IconInterface) => (
  <svg
    enableBackground='new 0 0 128 128'
    className={className}
    height={height}
    width={width}
    id='Layer_1'
    version='1.1'
    viewBox='0 0 128 128'
    xmlSpace='preserve'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g>
      <circle cx='64' cy='64' fill='#00C80F' r='64' />
    </g>
    <g>
      <path
        d='M100.228,93.134C106.207,88.885,110,82.557,110,75.49c0-12.795-12.431-23.168-27.767-23.168   c-15.335,0-27.766,10.373-27.766,23.168c0,12.793,12.431,23.165,27.766,23.165c3.322,0,6.507-0.486,9.458-1.378   c0.521-0.157,1.084-0.097,1.555,0.176l6.021,3.487c1.338,0.773,2.109,0.185,1.719-1.309l-1.309-4.986   C99.53,94.076,99.749,93.474,100.228,93.134z M72.979,71.832c-2.082,0-3.771-1.688-3.771-3.769c0-2.082,1.688-3.769,3.771-3.769   c2.08,0,3.77,1.687,3.77,3.769C76.746,70.145,75.06,71.832,72.979,71.832z M91.378,71.832c-2.082,0-3.769-1.688-3.769-3.769   c0-2.082,1.687-3.769,3.769-3.769s3.771,1.687,3.771,3.769C95.147,70.145,93.46,71.832,91.378,71.832z'
        fill='#FFFFFF'
      />
      <path
        d='M82.567,50.106c0.59,0,1.174,0.014,1.756,0.042C81.82,36.873,68.018,26.719,51.364,26.719   C32.937,26.719,18,39.15,18,54.486c0,8.43,4.514,15.982,11.64,21.074c0.671,0.479,0.979,1.321,0.766,2.118l-1.569,5.851   c-0.473,1.767,0.432,2.458,2.01,1.536l7.145-4.171c0.643-0.377,1.414-0.472,2.128-0.258c3.512,1.045,7.299,1.617,11.244,1.617   c0.602,0,1.201-0.015,1.794-0.041c-0.736-2.173-1.129-4.466-1.129-6.832C52.029,61.421,65.702,50.106,82.567,50.106z    M62.448,41.128c2.448,0,4.432,1.985,4.432,4.434s-1.983,4.433-4.432,4.433c-2.449,0-4.434-1.985-4.434-4.433   S59.999,41.128,62.448,41.128z M40.168,49.996c-2.449,0-4.434-1.985-4.434-4.434s1.985-4.433,4.434-4.433   c2.448,0,4.434,1.985,4.434,4.433S42.617,49.996,40.168,49.996z'
        fill='#FFFFFF'
      />
    </g>
  </svg>
)

export default Icon(IconWeChatApp)
